<template>
  <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      class="my_popup"
  >
    <div class="close">
      <van-icon name="cross" @click="close"/>
    </div>
    <div class="time-wrap">
      <span>下单倒计时：</span>
      <van-count-down :time="timeout" format="mm 分 ss 秒"/>
    </div>
    <div class="form">
      <div class="item">
        <div class="label">联系人姓名</div>
        <div class="input">
          <van-field v-model="receiverName" placeholder="请输入联系人姓名"/>
        </div>
      </div>
      <div class="item">
        <div class="label">联系人手机号</div>
        <div class="input">
          <van-field
              v-model="phone"
              type="tel"
              maxlength="11"
              placeholder="请输入联系人手机号"
          />
        </div>
      </div>
      <div class="btn-wrap">
        <div class="btn" @click="goPay">
          <span>提交订单</span>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {loaclSetUserInfo, localGetUserInfo} from "@/utils/storage";
import {getConfirmVirtualOrder} from "@/api/virtual";
import {cancelOrder} from "@/api/home";

export default {
  props: {
    orderId: Number,
    timeout: Number,
    goodsInfo: Object,
  },
  name: "virtual-order",
  data() {
    return {
      allowToPay: true,
      show: false,
      receiverName: localGetUserInfo("receiverName"),
      phone: localGetUserInfo("phone"),
    }
  },

  methods: {
    async goPay() {
      if (!this.receiverName) {
        return this.$toast.fail("请填写姓名");
      } else if (this.phone.length !== 11) {
        return this.$toast.fail("请输入正确的手机号");
      }
      const params = {
        m2oId: this.$store.state.nthUserInfo.userid,
        orderId:this.$props.goodsInfo.id,
        phone: this.phone,
        receiverName: this.receiverName
      };
      const {data: res} = await getConfirmVirtualOrder(params);
      if (res.code === 200) {
        loaclSetUserInfo({
          receiverName: this.receiverName,
          phone: this.phone
        });
        console.log(res,"@@@@RES")
        if (this.allowToPay) {
          await this.$store.dispatch("awaitBuyTimer", this.$props.goodsInfo.timeout)
          this.allowToPay = false;
          this.$router.push({
            path: "/pay",
            query: {
              data: JSON.stringify(this.$props.goodsInfo),
            }
          });
        }
      }
    },
    close() {
      console.log(this.orderId);

      if (this.orderId) {
        this.$dialog
            .confirm({
              title: "提醒",
              message: "是否取消订单",
            })
            .then(() => {
              this.cancelOrder();
            });
      } else {
        this.popupShow = false;
      }
    },
    async cancelOrder() {
      const {data: res} = await cancelOrder({
        m2oId: this.$store.state.nthUserInfo.userid,
        orderId: this.orderId,
      });

      if (res.code === 200) {
        this.$toast.fail("订单已取消");
        this.show = false;
      } else {
        this.show = false;
      }
    },
  }
}
</script>

<style scoped lang="less">
.my_popup {
  width: 90%;
  border-radius: 4px;
  box-shadow: 0px 8px 19px #dedede;
  padding: 20px;
  max-height: 90%;

  .time-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff991d;

    .van-count-down {
      color: #ff991d;
    }
  }

  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    color: #c8c9cc;
    font-size: 22px;
    cursor: pointer;
  }

  .form {
    .item {
      display: flex;

      justify-content: space-between;
      align-items: center;

      .label {
        width: 70px;
        color: #666;

        // text-align: justify;
      }

      .input {
        /deep/ .van-field__control {
          display: block;
          box-sizing: border-box;
          width: 100%;
          min-width: 0;
          margin: 0;
          padding: 10px;
          color: #323233;
          line-height: inherit;
          text-align: left;
          background-color: #eee;
          border: 0;
          resize: none;
        }
      }

      .input {
        flex: 1;
      }
    }
  }

  .btn-wrap {
    display: flex;

    justify-content: space-between;
    align-items: center;

    .btn {
      width: 94%;
      line-height: 40px;
      background: #ff991d;
      border-radius: 20px;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 10px;
    }

    .btn-cancel {
      background: #fff;
      border-radius: 20px;
      border: 1px solid #ff991d;
      text-align: center;
      color: #ff991d;
    }
  }
}

</style>
